<template>
  <div id="app">
    <h-header :hcurID='hcurID'></h-header>
    <router-view></router-view>
		<foot></foot>
  </div>
</template>

<script>

export default {
  name: 'app',
  data(){
		return{
			hcurID:''
		}
	},
	created() {
			if(this.$route.path=='/'){
				this.hcurID = 1407;
			}else{
				this.hcurID = this.$route.params.id
			}
	},
	watch :{
		'$route' (to, from) {
				// 对路由变化作出响应...
				
				if(this.$route.path=='/'){
					this.hcurID = 1407;
				}else{
					this.hcurID = this.$route.params.id
				}
		}
	},
}
</script>

<style></style>
